module.exports = __webpack_public_path__ + "static/media/corporate-services-img28.ec72a3c3.jpg";